import { createFileRoute } from '@tanstack/react-router';
import { P } from '@vagusx/shared';
import CampaignsPage from '@/pages/campaigns/CampaignsPage';
import { requireRoutePermission } from '@/lib/route-guard';

export const Route = createFileRoute('/_authenticated/campaigns/')({
  beforeLoad: () => requireRoutePermission(P.OUTREACH_VIEW),
  component: CampaignsPage,
});
